import React from 'react'
import parse from 'html-react-parser'
import Image from 'next/image'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

import Header from 'app/BuktiKaryaPage/components/Header'
import { DocCollectionSection } from '../blocks/DocCollectionSection'
import { DocUploader } from '../blocks/DocUploader'
import { useBCKSInvitationCollection } from './useBCKSInvitationCollection'

import type { PMMKSInvitationPageContentType } from './ModelBCKSContentPage'

export const BCKSInvitationCollectionPage = (
  props: PMMKSInvitationPageContentType
) => {
  const {
    handleCopyUrlClick,
    textContent,
    isDocValid,
    handleDocUpload,
    isUploading,
    docList,
    currentDoc,
    currentUploadingDoc,
    handleMutateDocList,
    handleRemoveTempDoc,
    // TODO: use later
    isReviewMode,
    handleSaveDraft,
    handleNextStep,
    isDocDraftValid,
  } = useBCKSInvitationCollection(props)
  if (currentDoc.name) {
    return (
      <DocUploader
        setDoc={handleDocUpload}
        selectedDocMeta={currentDoc}
        docData={docList[currentDoc.name]}
        onDocUpload={handleMutateDocList}
        isReviewMode={isReviewMode}
        onBackClick={handleNextStep}
      />
    )
  }

  return (
    <div className="relative flex flex-col h-screen max-w-xl mx-auto">
      <Header title={textContent.collectionHeaderTitle} forceNavigateBack />

      <div className="bg-[#ECF5FE] p-4">
        <Text variant="body-sm">
          Catatan: Pastikan dokumen asli (<strong>bukan fotokopi</strong>),
          ukuran <strong>maks. 5 MB</strong>.
        </Text>
      </div>

      <div className="p-4">
        <section className="flex mb-4 p-4 border border-subdued rounded-lg md:hidden lg:hidden">
          <div className="w-36 mr-4">
            <Image
              layout="fixed"
              src="/images/img-typing-monitor.png"
              width={84}
              height={84}
              alt="Ilustrasi pengunggahan berkas"
            />
          </div>
          <div>
            <Text variant="body-sm" color="subdued">
              {parse(
                'Pengunggahan berkas dianjurkan melalui platform web Merdeka Mengajar di <b>guru.kemdikbud.go.id</b>'
              )}
            </Text>

            <Button
              className="mt-4"
              color="black"
              size="sm"
              onClick={() => {
                handleCopyUrlClick('https://guru.kemdikbud.go.id/')
              }}
            >
              {textContent.collectionCopyURLButtonText}
            </Button>
          </div>
        </section>

        <DocCollectionSection
          title={textContent.collectionDocKinerjaTitle}
          subtitle={textContent.collectionDocKinerjaSubtitle}
          filePlaceholder={textContent.collectionUploadFilePlaceholder}
          fileData={
            isUploading && currentUploadingDoc.name === 'kinerja'
              ? { name: 'Hasil Penilaian Kinerja', url: 'dummyURL' }
              : { ...docList.kinerja }
          }
          isLoading={isUploading && currentUploadingDoc.name === 'kinerja'}
          onDocDeleteClick={() => {
            handleRemoveTempDoc('kinerja')
          }}
          onClick={() =>
            handleDocUpload({
              docName: 'kinerja',
            })
          }
        />

        <DocCollectionSection
          title={textContent.collectionDocPoliceTitle}
          subtitle={textContent.collectionDocPoliceSubtitle}
          filePlaceholder={textContent.collectionUploadFilePlaceholder}
          fileData={
            isUploading && currentUploadingDoc.name === 'police'
              ? { name: 'SKCK', url: 'dummyURL' }
              : { ...docList.police }
          }
          isLoading={isUploading && currentUploadingDoc.name === 'police'}
          onDocDeleteClick={() => {
            handleRemoveTempDoc('police')
          }}
          onClick={() =>
            handleDocUpload({
              docName: 'police',
            })
          }
        />

        <DocCollectionSection
          title={textContent.collectionDocManagerialTitle}
          subtitle={textContent.collectionDocManagerialSubtitle}
          filePlaceholder={textContent.collectionUploadFilePlaceholder}
          fileData={
            isUploading && currentUploadingDoc.name === 'managerial'
              ? { name: 'SK Manajerial', url: 'dummyURL' }
              : { ...docList.managerial }
          }
          isLoading={isUploading && currentUploadingDoc.name === 'managerial'}
          onDocDeleteClick={() => {
            handleRemoveTempDoc('managerial')
          }}
          onClick={() =>
            handleDocUpload({
              docName: 'managerial',
            })
          }
        />

        <DocCollectionSection
          title={textContent.collectionDocHealthTitle}
          subtitle={textContent.collectionDocHealthSubtitle}
          filePlaceholder={textContent.collectionUploadFilePlaceholder}
          fileData={
            isUploading && currentUploadingDoc.name === 'health'
              ? { name: 'SKK', url: 'dummyURL' }
              : { ...docList.health }
          }
          isLoading={isUploading && currentUploadingDoc.name === 'health'}
          onDocDeleteClick={() => {
            handleRemoveTempDoc('health')
          }}
          onClick={() =>
            handleDocUpload({
              docName: 'health',
            })
          }
        />

        <DocCollectionSection
          title={textContent.collectionDocDiciplineTitle}
          subtitle={textContent.collectionDocDiciplineSubtitle}
          filePlaceholder={textContent.collectionUploadFilePlaceholder}
          fileData={
            isUploading && currentUploadingDoc.name === 'discipline'
              ? { name: 'SK Bebas Hukuman', url: 'dummyURL' }
              : { ...docList.discipline }
          }
          isLoading={isUploading && currentUploadingDoc.name === 'discipline'}
          onDocDeleteClick={() => {
            handleRemoveTempDoc('discipline')
          }}
          onClick={() =>
            handleDocUpload({
              docName: 'discipline',
            })
          }
        />

        <div className="flex flex-row items-center">
          <Button
            fullWidth
            className="mr-2"
            size="lg"
            color="white"
            disabled={!isDocDraftValid}
            onClick={handleSaveDraft}
          >
            {textContent.collectionDrafButtonText}
          </Button>

          <Button
            fullWidth
            className="ml-2"
            size="lg"
            color="black"
            disabled={!isDocValid}
            onClick={handleNextStep}
          >
            Lanjutkan
          </Button>
        </div>
      </div>
    </div>
  )
}
